export default __webpack_public_path__ + "static/media/img6ftD.89b30d83.png";